module.exports = __webpack_public_path__ + "static/media/ck-nav-logo-2022.edb58b9d.svg";